import React from 'react'
import PropTypes from 'prop-types'
import { times } from 'lodash-es'

import './PanesComponent.scss'

const PanesComponent = ({
  numberOfPanes = 0,
  direction = 'row',
  renderPane = () => {},
}) => (
  <div className={`panes-component panes-component-${direction}`}>
    {times(numberOfPanes, (index) => (
      <div key={index} className="panes-component-pane">
        {renderPane(index)}
      </div>
    ))}
  </div>
)

PanesComponent.propTypes = {
  numberOfPanes: PropTypes.number,
  direction: PropTypes.oneOf(['row', 'column']),
  renderPane: PropTypes.func,
}

// eslint-disable-next-line import-x/no-default-export
export default PanesComponent
